import { Separator } from "@/components/ui/separator";
import { Paragraph } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import Image from "next/image";

function CourseTeacher({ teacher }) {
  return (
    <div className="group/teacher-card relative flex flex-col border border-grayscale-input rounded-xl overflow-hidden pb-20">
      <div
        className={cn(
          "flex justify-center w-full h-43 bg-linear-to-b",
          "from-primary-bg to-gray-light pointer-events-none"
        )}
      >
        <Image
          src={teacher.profilePic}
          alt={teacher.name}
          height={150}
          width={160}
          className="h-37.5 w-auto mt-auto"
        />
      </div>

      <div className="absolute inset-0 flex flex-col justify-end overflow-hidden">
        <div className="space-y-2 p-3 bg-primary-foreground rounded-t-xl w-full group-hover:-mt-full duration-500">
          <div className="flex flex-col gap-y-1">
            <Paragraph
              variant="b3"
              weight="sb"
              className="text-grayscale-header-weak"
            >
              {teacher.name}
            </Paragraph>
            <Paragraph variant="b5-tight" className="text-grayscale-label">
              Faculty
            </Paragraph>
          </div>
          <Separator className="bg-linear-to-r from-grayscale-line to-grayscale-input opacity-60" />
          <Paragraph
            variant="b5-tight"
            weight="sb"
            className="text-grayscale-label"
          >
            {teacher.designation}
          </Paragraph>
        </div>

        <div
          className={cn(
            "h-63 p-3 bg-linear-to-b from-primary-bg to-gray-light",
            "box-border -mb-63 group-hover/teacher-card:m-0 duration-500"
          )}
        >
          <ul className="overflow-scroll scrollbar-hide">
            {teacher.description?.split("\n")?.map((item, index) => (
              <li
                key={`author-${teacher.id}-highlight-${index}`}
                className="mb-2"
              >
                <Paragraph variant="b5-tight" className="text-grayscale-label">
                  {item}
                </Paragraph>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CourseTeacher;
